import { getCompanyId } from '@/utils/getCompanyId'

const laserProfileMapping = (data) => {
  const companyId = getCompanyId()
  return {
    id: data.id,
    name: data.name,
    company_id: companyId,
    description: data.description,
    laser_properties: {
      id: data.laser_properties_id,
      wobble_overlap_percentage: Number(data.wobble_overlap_percentage),
      wobble_thickness: Number(data.wobble_thickness),
      power: Number(data.power),
      jump_speed: Number(data.jump_speed),
      marking_speed: Number(data.marking_speed),
      jump_delay: Number(data.jump_delay),
      laser_on_delay: Number(data.laser_on_delay),
      laser_off_delay: Number(data.laser_off_delay),
      mark_delay: Number(data.mark_delay),
      poly_delay: Number(data.poly_delay),
      pipeline_delay: Number(data.pipeline_delay),
      modulation_frequency: Number(data.modulation_frequency),
      // duty cycle inputs are hidden in LaserProfileForm; they always mirror power
      duty_cycle_one: Number(data.power),
      duty_cycle_two: Number(data.power),
      repeat_count: Number(data.repeat_count),
      pulse_waveform: Number(data.pulse_waveform),
      velocity_compensation_mode: data.velocity_compensation_mode,
      velocity_compensation_limit: Number(data.velocity_compensation_limit),
      velocity_compensation_aggressiveness: Number(data.velocity_compensation_aggressiveness),
      max_radial_error: Number(data.max_radial_error),
      break_angle: Number(data.break_angle),
    },
  }
}
export default laserProfileMapping
